class DateUtils {
  isoDate = (date) => {
    const index = date.indexOf('T');
    const calendarDate = date.substring(index, 0).split('-');

    const year = calendarDate[0];
    const month = calendarDate[1];
    const day = calendarDate[2];

    return `${month}/${day}/${year}`;
  };

  formatIsoToDateWithHours = (date) => {
    const newDateArray = new Date(date)
      .toLocaleString('en', {
        timeZone: 'america/chicago',
        hourCycle: 'h24',
      })
      .toString()
      .split(',');

    const calendarDate = newDateArray[0].split('/');

    const year = calendarDate[2];
    const month = calendarDate[0];
    const day = calendarDate[1];

    return `${this.getMonthString(parseInt(month))} ${day}, ${year}${
      newDateArray[1]
    } CST (Central Stantard Time)`;
  };

  formatIsoToCommomDate = (date) => {
    const newDateArray = date.split('T')[0].split('-');

    const year = newDateArray[0];
    const month =
      parseInt(newDateArray[1]) < 10
        ? `0${parseInt(newDateArray[1])}`
        : parseInt(newDateArray[1]);
    const day =
      parseInt(newDateArray[2]) < 10
        ? `0${parseInt(newDateArray[2])}`
        : parseInt(newDateArray[2]);

    return `${month}/${day}/${year}`;
  };

  formatIsoToDate = (date) => {
    const newDateArray = date.split('T')[0].split('-');

    const year = newDateArray[0];
    const month = newDateArray[1];
    const day = newDateArray[2];

    return `${this.getMonthString(parseInt(month))} ${day}, ${year}`;
  };

  formatIsoToSmallDate = (date) => {
    const newDateArray = new Date(date)
      .toLocaleString('en', {
        timeZone: 'america/chicago',
        hourCycle: 'h24',
      })
      .toString()
      .split(',');

    const calendarDate = newDateArray[0].split('/');

    const year = calendarDate[2];
    const month = calendarDate[0];
    const day = calendarDate[1];

    return `${this.getSmallMonthString(
      parseInt(month)
    )} ${day}, ${year}`;
  };

  addYears = (date, years) => {
    const currentDate = new Date(date);
    const newDate = new Date(date);

    newDate.setFullYear(currentDate.getFullYear() + years);

    return newDate.toISOString();
  };

  getMonthString = (month) => {
    switch (month) {
      case 1:
        return 'January';

      case 2:
        return 'February';

      case 3:
        return 'March';

      case 4:
        return 'April';

      case 5:
        return 'May';

      case 6:
        return 'June';

      case 7:
        return 'July';

      case 8:
        return 'August';

      case 9:
        return 'September';

      case 10:
        return 'October';

      case 11:
        return 'November';

      case 12:
        return 'December';

      default:
        return 'Error';
    }
  };

  getSmallMonthString = (month) => {
    switch (month) {
      case 1:
        return 'Jan';

      case 2:
        return 'Feb';

      case 3:
        return 'Mar';

      case 4:
        return 'Apr';

      case 5:
        return 'May';

      case 6:
        return 'Jun';

      case 7:
        return 'Jul';

      case 8:
        return 'Aug';

      case 9:
        return 'Sep';

      case 10:
        return 'Oct';

      case 11:
        return 'Nov';

      case 12:
        return 'Dec';

      default:
        return 'Error';
    }
  };

  timestamp = (date, timezone) => {
    const calendar = new Date(date).toLocaleDateString('en-US', {
      timeZone: timezone,
      hour12: false,
    });

    const time = new Date(date).toLocaleTimeString('en-US', {
      timeZone: timezone,
      hour12: false,
    });

    return `${calendar} at ${time}`;
  };

  getTimezone = async () => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      console.log(
        'You can not see the correct timezone, because your browser is blocking the request'
      );
    }
  };
}

export default DateUtils;
